import { createContext } from 'react'

const notImplemented = () => console.error('not implemented!')

const CreateNewContext = createContext({
    create: notImplemented,
})

export default CreateNewContext
